module.exports = __webpack_public_path__ + "static/media/banner_font_icon.0b63601d.svg";